import {ButtonPrimary, ButtonSecondary, Input, ModalBase, ProgressIndicatorCircular} from "pac-ux-components";
import React, {useEffect} from "react";
import {useCookies} from "react-cookie";

function EditTenantModal(props) {

    const [tenant, setTenant] = React.useState({});
    const [loading, setLoading] = React.useState(true);
    const [saving, setSaving] = React.useState(false);
    const apiRoot = process.env.REACT_APP_API_ROOT_URL;
    const [cookies] = useCookies(['idToken']);
    const apiHeaders = {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + cookies.idToken
    }


    useEffect(() => {
        fetch(apiRoot + '/backoffice/tenants/' + props.tenant.id, {headers: apiHeaders})
            .then((response) => response.json())
            .then(json => setTenant(json))
            .then(() => setLoading(false));
    }, []);

    return (<div>
        <ModalBase
            style={{display: (props.display === true) ? 'block' : 'none'}}
        >
            {loading ? (<div style={{
                width: 619,
                height: 478,
                fontFamily: 'Inter',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                margin: '0 auto',
            }}>
                <ProgressIndicatorCircular style={{margin: '0 auto'}}/></div>) : (<form
                onSubmit={async (e) => {
                    e.preventDefault();
                    setSaving(true);
                    await props.handleSave(tenant);
                    e.stopPropagation();
                    return;
                }}
            >
                <div style={{width: '619px', height: '478px', paddingLeft: 33, fontFamily: 'Inter'}}>
                    <div style={{
                        width: '100%',
                        color: 'black',
                        fontSize: 24,
                        fontWeight: '700',
                        marginTop: 38,
                        wordWrap: 'break-word'
                    }}>Edit Tenant
                    </div>
                    <div style={{
                        width: '100%',
                        color: 'black',
                        fontSize: 16,
                        fontWeight: '400',
                        marginTop: 10,
                        height: 54,
                        wordWrap: 'break-word'
                    }}>Edit the tenant detail
                    </div>

                    <div style={{
                        width: '100%',
                        color: 'black',
                        fontSize: 16,
                        fontWeight: '400',
                        wordWrap: 'break-word',
                        marginBottom: 4,
                    }}>Tenant Name
                    </div>
                    <Input value={tenant.name}
                           onChange={(e) => {
                               setTenant({
                                   ...tenant, name: e.target.value, // Update the specific field in tenant object
                               })
                           }}
                           required={true}
                           style={{
                               background: 'white',
                               borderRadius: 2,
                               border: '1px #949494 solid',
                               width: 530,
                               height: 40,
                               margin: '8px 0px'
                           }}
                    />

                    <div style={{
                        width: '100%',
                        color: 'black',
                        fontSize: 16,
                        fontWeight: '400',
                        wordWrap: 'break-word',
                        marginBottom: 4,
                        marginTop: 32,
                    }}>Secret Signature
                    </div>
                    <Input value={tenant.signatureSecret.trim()}
                           onChange={(e) => {
                               setTenant({
                                   ...tenant, signatureSecret: e.target.value,
                               })
                           }}
                           required={true}
                           style={{
                               background: 'white',
                               borderRadius: 2,
                               border: '1px #949494 solid',
                               width: 530,
                               height: 40,
                               margin: '8px 0px'
                           }}
                    />
                    <div style={{
                        width: '100%',
                        color: 'black',
                        fontSize: 16,
                        fontWeight: '400',
                        wordWrap: 'break-word',
                        marginBottom: 4,
                        marginTop: 32,
                    }}>Airline ICAO
                    </div>
                    <Input value={tenant.airlineIcao || ''}
                           onChange={(e) => {
                               setTenant({
                                   ...tenant,airlineIcao :  e.target.value === "" ? null : e.target.value,
                               })
                           }}
                           required={false}
                           minLength={3}
                           maxLength={3}
                           pattern=".{3}"
                           title="Airline ICAO code must be exactly 3 characters"
                           style={{
                               background: 'white',
                               borderRadius: 2,
                               border: '1px #949494 solid',
                               width: 530,
                               height: 40,
                               margin: '8px 0px'
                           }}
                    />


                    <div style={{
                        width: '100%',
                        color: 'black',
                        fontSize: 16,
                        fontWeight: '400',
                        wordWrap: 'break-word',
                        marginBottom: 4,
                        marginTop: 32,
                    }}>Tenant ID
                    </div>
                    <div style={{
                        width: '100%',
                        color: '#7A7A7A',
                        fontSize: 16,
                        fontWeight: '400',
                        wordWrap: 'break-word',
                        marginBottom: 4,
                        marginTop: 8,
                    }}>{tenant.id}
                    </div>
                </div>

                <div style={{
                    float: 'right', marginBottom: 32, marginRight: 32,
                }}>

                    <ButtonSecondary
                        type='cancel'
                        onClick={props.closeModal}
                        style={{
                            marginRight: 32,
                        }}>Cancel</ButtonSecondary>

                    <ButtonPrimary
                        type='submit'
                        disabled={saving}
                    >Save</ButtonPrimary>
                </div>
            </form>)}
        </ModalBase>
    </div>);
}

export default EditTenantModal;